import ActiveService from "rapid/service.active";

export class UndoDeleteService extends ActiveService {
    /**
     *
     * @param $injector
     */
    constructor($injector, $auth, $q) {
        "ngInject";
        super($injector);
        this.$auth = $auth;
        this.$q = $q;
    }

    undoDelete(collection, id) {
        return this.$auth.$http({
                url: `/api/${collection}/${id}/undo_delete/?all=true`,
                method: "PUT"
            }).then(() => {
                this.$q.resolve();
            }).catch(() => {
                this.$q.reject();
            });
    }

}



// WEBPACK FOOTER //
// ./sources/services/undo-delete.js